import { render } from "./FormsList.vue?vue&type=template&id=2898ed0b&scoped=true"
import script from "./FormsList.vue?vue&type=script&lang=js"
export * from "./FormsList.vue?vue&type=script&lang=js"

import "./FormsList.vue?vue&type=style&index=0&id=2898ed0b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2898ed0b"]])

export default __exports__